export type BatchApplyTargetResolution<T> = {
  hasSelection: boolean
  targetRows: T[]
  skippedRows: T[]
}

export type BatchTableSelectionChangeDetail = {
  selectedIds: string[]
}

export const resolveBatchApplyTargets = <T>({
  filteredRows,
  selectedIds,
  getId,
  isEligible = () => true,
}: {
  filteredRows: T[]
  selectedIds?: string[] | Set<string> | null
  getId: (row: T) => string
  isEligible?: (row: T) => boolean
}): BatchApplyTargetResolution<T> => {
  const selected =
    selectedIds instanceof Set ? selectedIds : new Set((selectedIds ?? []).map(String))
  const hasSelection = selected.size > 0
  const scopedRows = hasSelection
    ? filteredRows.filter((row) => selected.has(getId(row)))
    : filteredRows
  const targetRows: T[] = []
  const skippedRows: T[] = []

  for (const row of scopedRows) {
    if (isEligible(row)) {
      targetRows.push(row)
    } else {
      skippedRows.push(row)
    }
  }

  return {
    hasSelection,
    targetRows,
    skippedRows,
  }
}
